// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 216) return "css/vendors.31d6cfe0d16ae931b73c.css";
	if (chunkId === 592) return "css/common.31d6cfe0d16ae931b73c.css";
	if (chunkId === 584) return "css/news_list.undefined.css";
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"58":"form-validation","64":"intl-tel-input","342":"anime","756":"validation","960":"slimselect"}[chunkId] + "." + {"58":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","342":"31d6cfe0d16ae931b73c","756":"31d6cfe0d16ae931b73c","960":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
};